import { FunnelImage } from '../Content';
import { PageSection } from './SectionAttributes';
import { SectionType } from './SectionType';

export enum ListItemVariant {
  SLIDER = 'SLIDER',
  PROGRESS = 'PROGRESS',
  TEXT = 'TEXT',
}

export type SliderListItem = {
  title: string;
  label: string;
  value: number;
  color?: string;
  textColor?: string;
  variant: ListItemVariant.SLIDER;
};

export type ProgressListItem = {
  title: string;
  label: string;
  value: number;
  color?: string;
  textColor?: string;
  variant: ListItemVariant.PROGRESS;
};

export type TextListItem = {
  title: string;
  text: string;
  variant: ListItemVariant.TEXT;
};

export type ListItem = SliderListItem | ProgressListItem | TextListItem;

type BeforeAfter = {
  title: string;
  image: FunnelImage;
  list: Array<ListItem>;
};

export interface SectionBeforeAfterAttributes extends PageSection {
  content: {
    title?: string;
    before: BeforeAfter;
    after: BeforeAfter;
    connectorImage?: FunnelImage;
  };
  sectionType: SectionType.BEFORE_AFTER;
}
